import React from 'react';

const ContractLogo = ({ organization }) => {
  if (!organization || !organization.image) {
    return null;
  }
  return (
    <div style={{ minHeight: 85 }}>
      <img src={organization.image} style={{ maxHeight: 70 }} alt="logo" />
    </div>
  );
};

export default ContractLogo;



// WEBPACK FOOTER //
// ./src/components/common/ContractComponent/ContractLogo/index.js